import { useContext } from 'react'

import { DocFlowContext } from '../../DocFlow.context'

export function useDocFlowContext() {
  return useContext(DocFlowContext)
}
